const { permissions } = require('../../../../constants/permissions');
const SaaSSubscription = require('../../../../model/SaaSSubscription');
const SERVER_API = 'api/v1/';

class SaaSSubscriptionPersistenceService {
    constructor(config, $rootScope, $q, crudService, sharedPersistenceService, storageService, iamPersistenceService) {
        this._crudService = crudService;
        this._sharedPersistence = sharedPersistenceService;
        this.iamPersistenceService = iamPersistenceService;
        this.$rootScope = $rootScope;
        this._$q = $q;
        this.registryUrl = config.registryUrl;
        this.storageService = storageService
        this.REST_ENDPOINTS = this._sharedPersistence.getRestEndpoints();
    }


    getSaasSubscriptions() {
        let url = this.registryUrl + SERVER_API + 'saasSubscriptions/dropDown';
        return this._crudService.get(url, null, null, null, null, true, true, false).then(res => {
            return res.data.entities;
        })

    }

    getSaasSubscriptionData(uuid) {
        let url = this.registryUrl + SERVER_API + 'saasSubscriptions/' + uuid;

        if (!this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET)) {
            return this._$q((resolve) => { resolve([]) })
        }

        return this._crudService.get(url, null, null, null, null, true, true, false).then(res => {
            return SaaSSubscription.fromRaw(res.data.entities[0]);
        })
    }

    getResourceGroupsFromAzure(uuid) {
        let url = this.registryUrl + SERVER_API + 'subscriptions/' + uuid + '/resourceGroups/azure/dropDown';

        if (!this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET)) {
            return this._$q((resolve) => { resolve([]) })
        }

        return this._crudService.get(url, null, null, null, null, true, true, false).then(res => {
            return res.data.entities;
        })
    }

    getBillingPlans(uuid) {
        let url = this.registryUrl + SERVER_API + 'saasSubscriptions/' + uuid + '/plans/dropDown';

        if (!this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET)) {
            return this._$q((resolve) => { resolve([]) })
        }

        return this._crudService.get(url, null, null, null, null, true, true, false).then(res => {
            return res.data.entities;
        })
    }

    updateBillingPlan(uuid, data) {
        let url = this.registryUrl + SERVER_API + 'saasSubscriptions/' + uuid;
        return this._crudService.put(url, data, null, true, true, true).then(res => {
            return res;
        })
    }

    unsubscribeSaasSubscription(uuid) {
        let url = this.registryUrl + SERVER_API + 'saasSubscriptions/' + uuid;
        return this._crudService.del(url, null, null, null, true, true, true).then(res => {
            return res;
        })
    }

    sendCustomerTestEmail(data) {
        let bodyData = {
            email: data
        }
        let url = this.registryUrl + SERVER_API + 'saasCustomers/email/test';
        return this._crudService.post(url, bodyData, null, true, null, true, true).then(res => {
            return res;
        })
    }

    saveCustomerEmail(uuid, data) {
        let bodyData = {
            email: data
        }
        let url = this.registryUrl + SERVER_API + 'saasCustomers/' + uuid + '/email';
        return this._crudService.put(url, bodyData, null, true, true, true).then(res => {
            return res;
        })
    }

}

SaaSSubscriptionPersistenceService.$inject = ['config', '$rootScope', '$q', 'crudService', 'sharedPersistenceService', 'storageService', 'iamPersistenceService'];

module.exports = SaaSSubscriptionPersistenceService;




// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/saasSubscription/saasSubscription.persistence.service.js